import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MainLayout } from '@/components/layout';
import { appConfig, motionConfig } from '@/lib/config';
import { Button } from '@/components/ui';
import { useAuthStore } from '@/stores/auth.store';
import { useRoomsQuery } from '@/hooks/useRooms';
import { RoomCard } from '@/components/room';

export function HomePage() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const { data: roomsData } = useRoomsQuery(
    { limit: 6, sort: 'newest' },
    isAuthenticated,
  );
  const recentRooms = roomsData?.data ?? [];

  return (
    <MainLayout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
        <motion.div {...motionConfig.slideUp} className="text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight">
            <span className="text-gradient">{appConfig.name}</span>
          </h1>
          <p className="mt-4 text-lg sm:text-xl text-surface-500">Watch anything together with friends.</p>
        </motion.div>

        <motion.div
          {...motionConfig.slideUp}
          className="mt-12 flex flex-col sm:flex-row gap-4 justify-center"
        >
          {isAuthenticated ? (
            <>
              <Link to="/rooms" className="flex-1 sm:flex-none">
                <Button size="lg" className="w-full sm:min-w-[200px]">
                  Create Room
                </Button>
              </Link>
              <Link to="/join" className="flex-1 sm:flex-none">
                <Button variant="secondary" size="lg" className="w-full sm:min-w-[200px]">
                  Join Room
                </Button>
              </Link>
            </>
          ) : (
            <>
              <Link to="/guest" className="flex-1 sm:flex-none">
                <Button size="lg" className="w-full sm:min-w-[200px]">
                  Get Started
                </Button>
              </Link>
              <Link to="/join" className="flex-1 sm:flex-none">
                <Button variant="secondary" size="lg" className="w-full sm:min-w-[200px]">
                  Join Room
                </Button>
              </Link>
            </>
          )}
        </motion.div>

        {isAuthenticated && recentRooms.length > 0 ? (
          <section className="mt-16">
            <h2 className="text-lg font-semibold mb-4">Recent Rooms</h2>
            <div className="grid gap-3">
              {recentRooms.map((room, i) => (
                <RoomCard key={room.id} room={room} index={i} />
              ))}
            </div>
          </section>
        ) : null}
      </div>
    </MainLayout>
  );
}
